export default class Joueur {
    numero = null
    parties = []
    contre = []
    amis = []
    error = false
    options = null;
    coequipier1 = null;
    coequipier2 = null;
    errorDetail = {};
    gagnes = 0;
    gagnesByPartie=[];
   
    constructor(options, numero, parties, amis, contre, error, gagne, gagnesByPartie) {
        this.numero = numero;
        this.options = options;
        if (typeof(parties) != "undefined")
            this.parties = parties;
        if (typeof(amis) != "undefined")
            this.amis = amis;
        if (typeof(contre) != "undefined")
            this.contre = contre;
        if (typeof(error) != "undefined")
            this.error = error;
        if (typeof(gagne) != "undefined")
            this.gagnes = gagne;
        if (typeof(gagnesByPartie) != "undefined")
            this.gagnesByPartie = gagnesByPartie.splice();
       
    }
    getJSON() {
        return {
            numero: this.numero,
            error: this.error,
            errorDetail: this.errorDetail,
            parties: this.parties
        }
    }
    static findEquipe (equipes, joueur) {
        var objectReturn = {
            indiceEquipe : null,
            vs: null,
            joueur : null
        }
        
        equipes.forEach((equipe, indiceEquipe)=>{
            
            for (var key in equipe.dataJoueurs)
                for (var joueur_loop in equipe.dataJoueurs[key]) {
                    
                    if (equipe.dataJoueurs[key][joueur_loop]!=null) {
                        if (objectReturn.indiceEquipe == null && equipe.dataJoueurs[key][joueur_loop].numero == joueur.numero) {
                            objectReturn.indiceEquipe = indiceEquipe;
                            objectReturn.vs = key;
                            objectReturn.joueur = joueur_loop;
                        }
                    }
                }   
        })
        return objectReturn;
    }
    static validAMI (joueur, dataJoueursJOUEURS, forcage) {
        var valid = true;
        if (typeof(forcage)=="undefined")
            forcage = null;
        if (forcage==3)
            return true
        else {
            for (var joueur_loop in dataJoueursJOUEURS) {
                if (dataJoueursJOUEURS[joueur_loop] != null) {
                    var numero = dataJoueursJOUEURS[joueur_loop].numero ;
                    valid = this.isNotInArray(joueur.amis, numero) && valid;
                }
            }
        
            return valid;
        }
    }
    static validAllEquipe (joueur, dataJoueurs) {
        var valid = true;
        for (var vs in dataJoueurs)
            for (var joueurLoop in dataJoueurs[vs])
                if (dataJoueurs[vs][joueurLoop]!=null) {
                    var numero = dataJoueurs[vs][joueurLoop].numero;
                    valid = this.isNotInArray(joueur.contre, numero) && valid;
                    valid = this.isNotInArray(joueur.amis, numero) && valid;
                }
        return valid;
    }
    static validCONTRE (joueur, dataJoueursCONTRE, forcage) {
        var valid = true;
        if (typeof(forcage)=="undefined")
            forcage = null;
        if (forcage==2)
            return true
        else {
            for (var joueur_loop in dataJoueursCONTRE) {
                if (dataJoueursCONTRE[joueur_loop] != null) {
                    var numero = dataJoueursCONTRE[joueur_loop].numero ;
                    valid = this.isNotInArray(joueur.contre, numero) && valid;
                }
            }
            return valid;
        }
    }
    
    static isNotInArray(tab, numero) {
        if (typeof(numero) == "undefined")
          return true;
        if (numero == null)
          return true;
        else {
          if (tab.indexOf(numero) == -1) {
              return true;
          }
          else
            return false;
        }
    }
    get() {
        return this.json;
    }
    pushKey(key, numero) {
        if (key =="contre") {
            this.pushOnlyOne(this.contre, numero);
        }
        else    
            this.pushOnlyOne(this.amis, numero);
    }
    pushOnlyOne(tab, numero) {
        if (tab.indexOf(numero) == -1)
            tab.push(numero);
    }
    static getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }
    
    pushAmis(dataJoueursAmis, indexPartie) {
     
        if (typeof(this.parties[indexPartie])=="undefined") {
            this.parties[indexPartie] = {
                joueurs: [],
                contre: []
            }
        }
        else if (this.parties[indexPartie]==null) {
            this.parties[indexPartie] = {
                joueurs: [],
                contre: []
            }
        }
        else {
            this.parties[indexPartie].joueurs = [];
        }
      
        for (var joueur_loop in dataJoueursAmis) {
            if (dataJoueursAmis[joueur_loop] != null) {
                if (this.numero != dataJoueursAmis[joueur_loop].numero) {/*
                    this.pushKey("amis", dataJoueursAmis[joueur_loop].numero);
                    if (typeof(this.parties[indexPartie])=="undefined") {
                        this.parties[indexPartie] = {
                            joueurs: [],
                            contre: []
                        }
                    }
                    
                    this.pushOnlyOne( this.parties[indexPartie].joueurs, dataJoueursAmis[joueur_loop].numero)
                    */
                   
                   this.pushOnlyOne( this.parties[indexPartie].joueurs, dataJoueursAmis[joueur_loop].numero)
                }
                    
            }
        }
        this.amis = [];
      
        this.parties.forEach(partie=>{
            if (partie==null)
                partie = {
                    joueurs: [],
                    contre: []
                }
            partie.joueurs.forEach(joueurNumero=>{
                this.pushOnlyOne (this.amis, joueurNumero);
            })
        })
     
    }
    pushContre(dataJoueursContre, indexPartie) {
        if (typeof(this.parties[indexPartie])=="undefined") {
            this.parties[indexPartie] = {
                joueurs: [],
                contre: []
            }
        }
        else if (this.parties[indexPartie]==null) {
            this.parties[indexPartie] = {
                joueurs: [],
                contre: []
            }
        }
        else {
            this.parties[indexPartie].contre = [];
        }
        for (var joueur_loop in dataJoueursContre) {
            if (dataJoueursContre[joueur_loop] != null) {
                if (this.numero != dataJoueursContre[joueur_loop].numero) {
                    /*
                    this.pushKey("contre", dataJoueursContre[joueur_loop].numero);
                    if (typeof(this.parties[indexPartie])=="undefined") {
                        this.parties[indexPartie] = {
                            joueurs: [],
                            contre: []
                        }
                    }
                    */
                    this.pushOnlyOne( this.parties[indexPartie].contre, dataJoueursContre[joueur_loop].numero)
                   
                }
                    
            }
        }
        
        this.contre = [];
        this.parties.forEach(partie=>{
            if (partie==null)
                partie = {
                    joueurs: [],
                    contre: []
                }
            partie.contre.forEach(joueurNumero=>{
                this.pushOnlyOne (this.contre, joueurNumero);
            })
        })
    }
    aDejaJoueEnTriplette () {
        // On va prendre les joueurs qui ont déjà joué en triplette en priorité !
        var aDejaJoueEnTriplette = false;
        this.parties.forEach(partie=>{
            if (!aDejaJoueEnTriplette) {
                aDejaJoueEnTriplette = partie.joueurs.length == 2
            }
        })
        return aDejaJoueEnTriplette;
    }
    static findNumeroRandom(numeroRestantJoueurs, joueurs, options) {
        

        var returnIndiceJoueur = null;
        var resteATrouver = numeroRestantJoueurs.length;
        
        var coeff = joueurs.length / 2;
        
        var nbJoueurLimite = (options.nbJoueursParEquipe == 2) ? 2 : 1;
        // Si le mode est forme alors on renvoir le numéro de son coequipier
       if (resteATrouver < (parseInt(coeff))) {
            // On reste si on est dans le cas où on aura des joueurs qui ne joueront pas certaines parties
                   
                // Alors on va tester si nombre de numeroRestantJoueurs 
                // si on voit qu'il reste des joueurs qui sont déjà en situation périlleuse
                // alors on va les tirer tout de suite !
                    
                    var findJoueur = false;
                    numeroRestantJoueurs.forEach((numero, indiceJoueurRestant)=>{
                        var joueur = joueurs[numero];
                       
                        joueur.parties.forEach((partie, indexPartie)=> {
                            if (options.nbJoueursParEquipe != 1) {
                               
                                if (!options.allEquipePlay) {
                                    if (!findJoueur && partie.joueurs.length == 0) {
                                        returnIndiceJoueur = indiceJoueurRestant;
                                        findJoueur = true;
                                    }
                                }
                                else {
                                   
                                    if (!findJoueur && 
                                        (partie.joueurs.length == nbJoueurLimite || partie.contre.length == (nbJoueurLimite+1))) {
                                        
                                        //console.log(numero)
                                        returnIndiceJoueur = indiceJoueurRestant;
                                        findJoueur = true;
                                    }
                                }
                            }
                            /*else {
                                console.log("STEP1.2")
                                if (indexPartie < joueur.parties.length - 1) {
                                    if (!findJoueur && partie.contre.length == 0) {
                                        findJoueur = true;
                                        returnIndiceJoueur = indiceJoueurRestant;
                                    }
                                }
                                        
                            }
                            */
                        })
                    })
                
        }
       
        if (returnIndiceJoueur == null) {
            return this.getRandomInt(numeroRestantJoueurs.length);
        }
        else {
            
            return returnIndiceJoueur;
        }
        
            
    }
    static random(min, max) {
        return Math.floor(min + Math.random() * (max - min));
    }
    static findJoueur(numeroRestantJoueurs, joueurs, dataJoueurs ,key, options, gagne, numeroRestantJoueursSave, forcage) {
       
        var randomNumero = this.findNumeroRandom(numeroRestantJoueurs, joueurs, options);
      
      
        var indiceJoueur = parseInt(numeroRestantJoueurs[randomNumero]);
        
        var joueur = joueurs[indiceJoueur];
       
       
        if (typeof(joueur) != "undefined") {
                var keyContre = key == 'joueurs' ? 'contre' : 'joueurs';
                var continueValid = true;
                if (typeof(forcage)=="undefined" || forcage==null)
                    continueValid = this.validAllEquipe(joueur, dataJoueurs)
                
                if (this.validAMI(joueur, dataJoueurs[key]) 
                    && this.validCONTRE(joueur,dataJoueurs[keyContre])
                    && continueValid
                    ) {
                    joueurs[indiceJoueur] = joueur;
                    return joueur;
                }
                else {
                     
                    if (numeroRestantJoueurs.length == 1 && forcage>0) {
                        joueur.error = 1;
                        joueurs[indiceJoueur] = joueur;
                        return joueur;
                    }
                    else {     
                        var numeroRestantJoueursOther = numeroRestantJoueurs.slice();
                        if (typeof(numeroRestantJoueursOther) == "undefined")
                            return null;
                        else {
                            var indexNumero = numeroRestantJoueursOther.indexOf(indiceJoueur);
                            numeroRestantJoueursOther.splice(indexNumero, 1);
                            if (numeroRestantJoueursOther.length==0) {

                                if (typeof(forcage)=="undefined" || forcage==null) {
                                    numeroRestantJoueursOther = numeroRestantJoueursSave.slice();
                                    forcage = 0;
                                }
                                else {
                                    numeroRestantJoueursOther = numeroRestantJoueursSave.slice();
                                    forcage ++;
                                }
                            }
                            return this.findJoueur(numeroRestantJoueursOther, joueurs, dataJoueurs ,key, options, gagne, numeroRestantJoueursSave, forcage);
                        }
                    }
                }
        }
        else
            return null;
    }
    playDoublette(vs, indexPartie) {
        var returnBoolean = false;
        this.parties.forEach((partie, indexPartieLoop)=>{
            if (!returnBoolean && partie[vs].length == 1 && indexPartieLoop < indexPartie)
                returnBoolean = true;
        })
        
        return returnBoolean;
    }
    playTriplette(vs, indexPartie) {
        var returnBoolean = false;
        this.parties.forEach((partie, indexPartieLoop)=>{
            if (!returnBoolean && partie[vs].length == 2 && indexPartieLoop < indexPartie)
                returnBoolean = true;
        })
        
        return returnBoolean;
    }
    isErrorInPartie(indexPartie) {
        return (typeof(this.errorDetail[indexPartie])!="undefined")
    }
    checkError() {
        var amisTempo =[];
        var contreTempo =[]
        var returnError = false;
        var nbJoueurOkParEquipe = false;
        var nbJoueurOkContreParEquipe = false;
        var jeuABlanc = false;
        this.errorDetail = {};
        this.error = 0;
        this.parties.forEach((partie,indexPartie)=>{
            if (partie!=null)
                if (partie.contre.length==0) {
                    if (jeuABlanc) {
                        returnError = true;
                        this.error = parseInt(this.error) + 2000;
                        var errorItem = {
                            indexPartie : indexPartie,
                            type: 6
                        }
                        if (typeof(this.errorDetail[indexPartie])=="undefined")
                            this.errorDetail[indexPartie] = [];
                        this.errorDetail[indexPartie].push(errorItem);
                    }
                    jeuABlanc = true;
                }
        })

        this.parties.forEach((partie, indexPartie)=>{
            // Bon pour se rappeler
            // en fait lorsqu'on est en doublette, le joueur n'a qu'1 seul AMI (bah oui : lui et son ami forment le duo)
            // du coup si le nombre de joueurs est égale à 2 alors c'est qu'on est en triplette
            // normalement on peut y être mais qu'une seule fois !!!
            // c'est peut être bizare de faire cette condition mais c'est pour mieux comprendre pourquoi
            if (partie!=null) {
            if (this.options.allEquipePlay && this.options.mode == "ALEA") {
                if (this.options.nbJoueursParEquipe == 2) {
                    if (partie.joueurs.length == 2) {
                        if (nbJoueurOkParEquipe) {
                            returnError = true;
                            if (this.error == 0)
                                this.error = parseInt(this.error) + 1500;
                            else
                                this.error = parseInt(this.error) + 15000;
                            var errorItem = {
                                indexPartie : indexPartie,
                                type: 3
                            }
                            if (typeof(this.errorDetail[indexPartie])=="undefined")
                                this.errorDetail[indexPartie] = [];
                            this.errorDetail[indexPartie].push(errorItem);
                        }
                        else
                            nbJoueurOkParEquipe = true;
                    }
                    if (partie.contre.length == 3) {
                        if (nbJoueurOkContreParEquipe) {
                            returnError = true;
                            this.error = parseInt(this.error) + 100;
                            var errorItem = {
                                indexPartie : indexPartie,
                                type: 5
                            }
                            if (typeof(this.errorDetail[indexPartie])=="undefined")
                                this.errorDetail[indexPartie] = [];
                            this.errorDetail[indexPartie].push(errorItem);
                        }
                        else
                            nbJoueurOkContreParEquipe = true;
                    }
                }
                if (this.options.nbJoueursParEquipe == 3) {
                    if (partie.joueurs.length == 1) {
                        if (nbJoueurOkParEquipe) {
                            returnError = true;
                            if (partie.contre.length == 3) {
                                this.error = parseInt(this.error) + 30;
                            }
                            else
                                this.error = parseInt(this.error) + 500;
                            var errorItem = {
                                indexPartie : indexPartie,
                                type: 3
                            }
                            if (typeof(this.errorDetail[indexPartie])=="undefined")
                                this.errorDetail[indexPartie] = [];
                            this.errorDetail[indexPartie].push(errorItem);
                        }
                        else
                            nbJoueurOkParEquipe = true;
                    }
                    if (partie.contre.length == 2) {
                        if (nbJoueurOkContreParEquipe) {
                            returnError = true;
                            this.error = parseInt(this.error) + 30;
                            var errorItem = {
                                indexPartie : indexPartie,
                                type: 5
                            }
                            if (typeof(this.errorDetail[indexPartie])=="undefined")
                                this.errorDetail[indexPartie] = [];
                            this.errorDetail[indexPartie].push(errorItem);
                        }
                        else
                            nbJoueurOkContreParEquipe = true;
                    }
                }
               /* if (partie.contre.length == 0 ) {
                    this.error = parseInt(this.error) + 5;
                    var errorItem = {
                        indexPartie : indexPartie,
                        type: 4
                    }
                    if (typeof(this.errorDetail[indexPartie])=="undefined")
                            this.errorDetail[indexPartie] = [];
                    this.errorDetail[indexPartie].push(errorItem);
                }*/
                // En triplette, c 'est étonnant d'être 2 fois tout seul avec au ami !
                // c'est une erreur enfin on peut peut être faire qqlque chose
                
            }
            else {
                if (partie.joueurs.length == 0 && this.options.mode == "ALEA" && this.options.nbJoueursParEquipe > 1) {
                    
                    if (nbJoueurOkParEquipe) {
                        returnError = true;
                        this.error = parseInt(this.error) + 50;
                        var errorItem = {
                            indexPartie : indexPartie,
                            type: 3
                        }
                        if (typeof(this.errorDetail[indexPartie])=="undefined")
                            this.errorDetail[indexPartie] = [];
                        this.errorDetail[indexPartie].push(errorItem);
                    }
                    else
                        nbJoueurOkParEquipe = true;
                }
            }
            /*    
            if (partie.contre.length == 3) {

            }
            */
           if (this.options.mode == "ALEA") {
                partie.joueurs.forEach(joueurNumero=>{
                    if (amisTempo.indexOf(joueurNumero) != -1) {
                            returnError = true;
                            if (this.error == 0)
                                this.error = parseInt(this.error)  + 1000;
                            else
                                this.error = parseInt(this.error)  + 20000;
                            var errorItem = {
                                indexPartie : indexPartie,
                                type: 2,
                                numero: joueurNumero
                            }
                            if (typeof(this.errorDetail[indexPartie])=="undefined")
                                this.errorDetail[indexPartie] = [];
                            this.errorDetail[indexPartie].push(errorItem);
                    }   
                    else {
                        amisTempo.push(joueurNumero);
                    }
                        
                })
                partie.contre.forEach(joueurNumeroCtr=>{
                    if (amisTempo.indexOf(joueurNumeroCtr) != -1) {
                            returnError = true;
                            this.error = parseInt(this.error)  + 1;
                            var errorItem = {
                                indexPartie : indexPartie,
                                type: 4,
                                numero: joueurNumeroCtr
                            }
                           
                            if (typeof(this.errorDetail[indexPartie])=="undefined")
                                this.errorDetail[indexPartie] = [];
                            this.errorDetail[indexPartie].push(errorItem);
                    }   
                    else {
                        amisTempo.push(joueurNumeroCtr);
                    }
                })
                
                
           }
                partie.contre.forEach(joueurNumero=>{
                    if (contreTempo.indexOf(joueurNumero) != -1) {
                        returnError = true;
                        if (this.error == 0)
                            this.error = parseInt(this.error)  + 800;
                        else
                           this.error = parseInt(this.error)  + 18000;
                        var errorItem = {
                            indexPartie : indexPartie,
                            type: 1,
                            numero: joueurNumero
                        }
                        if (typeof(this.errorDetail[indexPartie])=="undefined")
                            this.errorDetail[indexPartie] = [];
                        
                        this.errorDetail[indexPartie].push(errorItem);
                    }
                    else {
                        contreTempo.push(joueurNumero);
                    }
                    
                })
            }
        })
        
        return this.error ;
    }
}